actual suspend fun clearPlatformImageCache() = Unit
